export const featuredProperties = [
  {
    id: 1,
    slug: "villa-residencial-el-faro",
    title: "Villa en Residencial El Faro",
    location: "Torrevieja, Alicante",
    price: "€960,000",
    type: "En Venta",
    bedrooms: 4,
    bathrooms: 3,
    area: "290 m²",
    lat: 37.9781,
    lng: -0.6832,
    tags: [] as string[],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/908334f485f28133ee5b65171551c8d8.jpeg",
    description: "Villa independiente reformada con vista al mar. 3 plantas, piscina con vista al mar. Año de construcción 1999. Ubicada en Torrevieja.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/908334f485f28133ee5b65171551c8d8.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/89217c2b37d4ab97aa209c751445efa7.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/87817cc0df7dcc9e07848842e524eab8.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/2738c27b9f898264e4d856d8ba93d2d5.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/284e002c1b292393c85906ad26d1b1ae.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/507c9396ea4266841633e60aefac1026.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/3870cbaa7fcb36ada655a611c0542a5c.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/0c426a6b6456f8eef7ee5a2de671324a.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/f21b8b7d0897893c22de36b99ae40487.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/1dedb45a6deb4cae310d6093acca3b4b.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/438439fe79e39212b72a8f8e1a0e2bc3.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/53b59e907aa4e1b6e1653e6cd1643539.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/ce5628ab45f693e3bf3b06271d4c5e54.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/a105fb9057ad7553720e9b054b0d5281.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/a2e09e7c773507680d310fcc590fc5bd.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/3b9c7d64c2ede149cb329243eaf47876.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/ca8d205b2337a9edfebe5544a363886a.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/08719a3874f9b0f4c20a006cdf8ba33c.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/012c974a618d3e81592a07c601f673c2.jpeg"
    ]
  },
  {
    id: 2,
    slug: "apartamento-neptuno-ii",
    title: "Apartamento Neptuno II",
    location: "Costa, Alicante",
    price: "Desde €259,000",
    type: "En Venta",
    bedrooms: 2,
    bathrooms: 2,
    area: "Consultar",
    lat: 38.1833,
    lng: -0.5667,
    tags: ['construccion'],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/1ceeede9482f8ab2c1a43c238f5fbbf9.jpeg",
    description: "Con piscina, a minutos de la playa. 2 dormitorios y 2 baños. Precio entre 259.000 y 309.000 €. Preinstalación para paneles solares. Entrega estimada febrero 2027.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/1ceeede9482f8ab2c1a43c238f5fbbf9.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/fac145ff98b33f5695a18e793693cd1c.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/fa6cf8b63c0b8b93e8dcfdb5f0f209f5.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/8b023951b91c3f646c1ddcf511f6c7fe.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/6c1e0d31bff9fdeb005bc533ea25dc60.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/fc7be10e52d30d7d8d603a8df69751f5.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/93ef30126ee0d8b8c54d99a67549aaa6.jpeg"
    ]
  },
  {
    id: 3,
    slug: "villas-olivo-ii-fase-2",
    title: "Villas Olivo II — Fase 2",
    location: "Polop, Alicante",
    price: "Desde €568,000",
    type: "En Venta",
    bedrooms: 5,
    bathrooms: 3,
    area: "217 m² construidos",
    lat: 38.6167,
    lng: -0.1333,
    tags: ['construccion'],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/7a00204845d176b2a7b1b00fce49fb22.jpeg",
    description: "Villas independientes en parcelas de 425 m² y 217 m² de construcción. 10 min de las playas de Benidorm y Albir, 30 min de Alicante. 3 baños, 4 a 5 habitaciones. Precio de 568.000 a 638.650 €.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/7a00204845d176b2a7b1b00fce49fb22.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/a9a7f612cb431082bdc91599f8d83b48.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/9d25f1e309e10d711bbcfe2a709d6dd1.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/0b276e3d7999fcb958b7e1b8b1266ada.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/8dd2def3841f0441ebbfe84a20ad85be.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/6c06438d5c8947cf76fe9bfc4f53799e.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/d9536dc5ae2cdad072ea3e2db1465b04.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/472acc4e5b806875d49e8db283e703be.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/472acc4e5b806875d49e8db283e703be.jpeg"
    ]
  },
  {
    id: 4,
    slug: "residencial-alba-verde",
    title: "Residencial Alba Verde",
    location: "Costa del Mar Mediterráneo",
    price: "Desde €139,500",
    type: "En Venta",
    bedrooms: 3,
    bathrooms: 2,
    area: "Consultar",
    lat: 38.3452,
    lng: -0.4815,
    tags: ['construccion'],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/0fbcf66460326a052381edc7cb25cfa9.jpeg",
    description: "Apartamento de 3 habitaciones y 2 baños. A 15 min de las costas del mar Mediterráneo. Solárium con piscina. Precio desde 139.500 hasta 211.000 €.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/0fbcf66460326a052381edc7cb25cfa9.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/3daf29ed6edbc4a244a08c3d46d4e7ac.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/24bb01f5db9a47e01d7e94bf1eaba3b2.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/a5a2565526982a825a338ebfc0323c6e.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/270d44057a4371b94c33c0921343661e.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/3bea72cffcd8b15141cc8ce707920c85.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/2ed395a6a434e3240e991bdf0ee0c15d.jpeg"
    ]
  },
  {
    id: 5,
    slug: "casa-oranger-vistabella",
    title: "Casa Oranger — Vistabella Plaza Villas & Resort",
    location: "Vistabella Golf, Alicante",
    price: "Desde €315,000",
    type: "En Venta",
    bedrooms: 3,
    bathrooms: 3,
    area: "145.38 m²",
    lat: 37.8950,
    lng: -0.7820,
    tags: ['construccion'],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/d46dd5a67c68a02050af1066f318c311.jpeg",
    description: "Urbanización de 30 viviendas con piscina y parque infantil. 3 habitaciones, 3 baños, 95.95 m² construidos y 45.43 m² externos. A 1 min de bares y supermercados, 2 min del campo de golf, 20 min del hospital y 35 min del aeropuerto. Parking incluido.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/d46dd5a67c68a02050af1066f318c311.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/721b0803e07e87bd8245f885c05afc38.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/aecffb4470f71e7ec62ba32cc36c0a7f.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/62f33269aebc36f808b7af5e84d04f24.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/382b5fe2203f4f6e4ee03d4cee931732.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/b3f249d3c04af330b62388eeea25e9b4.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/97ac623f1490b3098e6a81a32593777f.jpeg"
    ]
  },
  {
    id: 6,
    slug: "local-comercial-hurchillo",
    title: "Local Comercial en Hurchillo",
    location: "Hurchillo, Orihuela",
    price: "Contacta para precio",
    type: "En Alquiler",
    bedrooms: 0,
    bathrooms: 0,
    area: "Consultar",
    lat: 38.0450,
    lng: -0.9120,
    tags: [] as string[],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/dcae263b80a9104e173572ea0552818b.jpeg",
    description: "Local comercial muy amplio, ideal para una academia, gimnasio o clases de yoga. Cuenta con vestidores y amplias zonas de actividad. Dispone de aparcamiento propio y se encuentra muy cerca de la plaza de Hurchillo. Una oportunidad perfecta para establecer un negocio de bienestar o educación en una zona residencial consolidada.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/dcae263b80a9104e173572ea0552818b.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/b231fd2ab9eefe1bc4bd841b9d8cab2a.jpeg"
    ]
  },
  {
    id: 7,
    slug: "local-comercial-centro-orihuela",
    title: "Local Comercial Centro de Orihuela",
    location: "Centro, Orihuela",
    price: "Contacta para precio",
    type: "En Alquiler",
    bedrooms: 0,
    bathrooms: 0,
    area: "Consultar",
    lat: 38.0849,
    lng: -0.9456,
    tags: [] as string[],
    image: "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/edae42814e654ecf25f40652f5e2af96.jpeg",
    description: "Local comercial muy amplio situado frente al Casino de Orihuela, en pleno centro de la ciudad. Ideal para pizzería, panadería o cualquier negocio de hostelería y alimentación. Ubicación privilegiada con gran afluencia de público, cerca del parking municipal y rodeado de todos los servicios del centro histórico de Orihuela.",
    photos: [
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/edae42814e654ecf25f40652f5e2af96.jpeg",
      "https://static.readdy.ai/image/9fcc4035fe7cce5c6ba56d5b353fae35/e7bf5aef981d3b6851283532d13feb45.jpeg"
    ]
  },
];

export const allProperties = [...featuredProperties];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "Compradora",
    avatar: "MG",
    color: "#E0F2FE",
    text: "Excelente servicio. El equipo de Red Lions Realty nos ayudó a encontrar la casa perfecta para nuestra familia. Profesionales, atentos y siempre disponibles."
  },
  {
    id: 2,
    name: "Carlos Martínez",
    role: "Vendedor",
    avatar: "CM",
    color: "#D1FAE5",
    text: "Vendí mi propiedad en tiempo récord gracias a su estrategia de marketing. Muy recomendables, superaron todas mis expectativas."
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    role: "Compradora",
    avatar: "AR",
    color: "#FCE7F3",
    text: "Increíble experiencia de principio a fin. Me guiaron en cada paso del proceso de compra y siempre con una sonrisa."
  },
  {
    id: 4,
    name: "Javier López",
    role: "Inversor",
    avatar: "JL",
    color: "#FEF3C7",
    text: "Como inversor, valoro la transparencia y el conocimiento del mercado. Red Lions Realty cumplió con creces en ambos aspectos."
  },
  {
    id: 5,
    name: "Laura Sánchez",
    role: "Compradora",
    avatar: "LS",
    color: "#E0E7FF",
    text: "Encontraron exactamente lo que buscaba. Su atención personalizada y dedicación hicieron toda la diferencia."
  },
  {
    id: 6,
    name: "Miguel Torres",
    role: "Vendedor",
    avatar: "MT",
    color: "#DBEAFE",
    text: "Profesionales de primer nivel. Gestionaron la venta de mi villa con total eficiencia y obtuve el mejor precio del mercado."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Patricia Ruiz",
    role: "Directora Comercial",
    image: "https://public.readdy.ai/ai/img_res/f2f87b6b61667aafcda4d6f73526b677.jpg",
    description: "15 años de experiencia en el sector inmobiliario"
  },
  {
    id: 2,
    name: "Roberto Fernández",
    role: "Agente Senior",
    image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20agent%20man%2C%20business%20portrait%2C%20friendly%20expression%2C%20modern%20office%20background%2C%20suit%20and%20tie%2C%20simple%20clean%20background%2C%20natural%20lighting&width=400&height=500&seq=team2fixed&orientation=portrait",
    description: "Especialista en propiedades de lujo"
  },
  {
    id: 3,
    name: "Carmen Jiménez",
    role: "Asesora Inmobiliaria",
    image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20agent%20woman%2C%20business%20portrait%2C%20warm%20smile%2C%20modern%20office%20background%2C%20professional%20clothing%2C%20simple%20clean%20background%2C%20natural%20lighting&width=400&height=500&seq=team3fixed&orientation=portrait",
    description: "Experta en primera vivienda y financiación"
  }
];
